// extracted by mini-css-extract-plugin
export default {"body":"animal-events-list_body__p8UL3"};